var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8323 10.0164L19.6199 2.22222C20.1267 1.71524 20.1267 0.895518 19.6199 0.388537C19.1133 -0.118445 18.2943 -0.118445 17.7877 0.388537L9.99989 8.18275L2.21228 0.388537C1.70548 -0.118445 0.88667 -0.118445 0.380103 0.388537C-0.126701 0.895518 -0.126701 1.71524 0.380103 2.22222L8.16771 10.0164L0.380103 17.8107C-0.126701 18.3176 -0.126701 19.1374 0.380103 19.6443C0.632556 19.8972 0.964493 20.0243 1.29619 20.0243C1.62789 20.0243 1.95959 19.8972 2.21228 19.6443L9.99989 11.8501L17.7877 19.6443C18.0404 19.8972 18.3721 20.0243 18.7038 20.0243C19.0355 20.0243 19.3672 19.8972 19.6199 19.6443C20.1267 19.1374 20.1267 18.3176 19.6199 17.8107L11.8323 10.0164Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearSearch);
export default __webpack_public_path__ + "static/media/clear-search.70214d8403355623afb7fa13a44ea3e5.svg";
export { ForwardRef as ReactComponent };